export default __webpack_public_path__ + "static/media/mainImg.05dc4822.png";